"use strict";

var _interopRequireDefault = require("D:/hhw/CadProject/cottiServer/cotti-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.iterator");
var _toConsumableArray2 = _interopRequireDefault(require("D:/hhw/CadProject/cottiServer/cotti-admin-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/hhw/CadProject/cottiServer/cotti-admin-web/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("D:/hhw/CadProject/cottiServer/cotti-admin-web/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("D:/hhw/CadProject/cottiServer/cotti-admin-web/node_modules/@babel/runtime/helpers/createClass.js"));
var _vue = _interopRequireDefault(require("vue"));
var _dictDetail = require("@/api/system/dictDetail");
var Dict = exports.default = /*#__PURE__*/function () {
  function Dict(dict) {
    (0, _classCallCheck2.default)(this, Dict);
    this.dict = dict;
  }
  return (0, _createClass2.default)(Dict, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(names, completeCallback) {
        var _this = this;
        var ps;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(names === undefined || name === null)) {
                _context.next = 1;
                break;
              }
              throw new Error('need Dict names');
            case 1:
              ps = [];
              names.forEach(function (n) {
                _vue.default.set(_this.dict.dict, n, {});
                _vue.default.set(_this.dict.label, n, {});
                _vue.default.set(_this.dict, n, []);
                ps.push((0, _dictDetail.get)(n).then(function (data) {
                  var _this$dict$n;
                  (_this$dict$n = _this.dict[n]).splice.apply(_this$dict$n, [0, 0].concat((0, _toConsumableArray2.default)(data.content)));
                  data.content.forEach(function (d) {
                    _vue.default.set(_this.dict.dict[n], d.value, d);
                    _vue.default.set(_this.dict.label[n], d.value, d.label);
                  });
                }));
              });
              _context.next = 2;
              return Promise.all(ps);
            case 2:
              completeCallback();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }]);
}();